import { EventContext, WidgetRequest, defaultRequests, getUserId, resetUserId, setTrackConsent, trackAddToCartEvent, trackAddToWishlistEvent, trackOrderConfirmEvent, trackStatusCartEvent, trackUserLoginEvent, trackViewEvent, } from '@sitecore-search/data';
import Actions from '../actions.js';
import Dispatcher from '../dispatcher.js';
import * as propStateMapper from '../propStateMapper.js';
import WidgetsConfig from '../widgetsConfig.js';
import { BaseController } from './baseController.js';
export const getDefaultRequestForWidget = (rfkId) => {
    const { type, options: { setupRequest = () => { } } = {} } = WidgetsConfig.get(rfkId) || {};
    const request = type ? defaultRequests.getDefaultRequestFor(type, rfkId) : new WidgetRequest(rfkId);
    request.setRfkId(rfkId);
    setupRequest(request);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore not sure why this is needed
    return request;
};
export const getInitialRequestForWidget = (rfkId) => {
    const request = getDefaultRequestForWidget(rfkId);
    propStateMapper.mapById(rfkId, request);
    return request;
};
export class Controller extends BaseController {
    constructor() {
        super();
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.setContext(EventContext.get());
        Dispatcher.subscribe(this);
    }
    getContext() {
        return this.context;
    }
    setContext(context) {
        this.context = context;
        this.context.addListener(this);
    }
    toggleTrackConsent(consent) {
        const currentUserId = getUserId();
        if (!consent) {
            resetUserId();
            setTrackConsent(false);
            currentUserId?.user_id && this.context.setUserId(currentUserId?.user_id);
        }
        else {
            if (currentUserId.user_id) {
                this.context.setUserId(currentUserId?.user_id);
            }
            else {
                this.context.setUserUuid(getUserId().uuid);
            }
        }
    }
    handleAction(action) {
        switch (action.type) {
            case Actions.INITIALIZE: {
                this.initialize();
                break;
            }
            case Actions.ADD_TO_CART: {
                const { entity, items } = action.payload;
                trackAddToCartEvent(entity, { items });
                break;
            }
            case Actions.ADD_TO_WISHLIST: {
                const { entity, items } = action.payload;
                trackAddToWishlistEvent(entity, { items });
                break;
            }
            case Actions.USER_LOGIN: {
                const { id, email } = action.payload;
                trackUserLoginEvent({ id, email });
                break;
            }
            case Actions.CART_STATUS: {
                const { entity, items } = action.payload;
                trackStatusCartEvent(entity, { items });
                break;
            }
            case Actions.ORDER_CONFIRM: {
                const { entity, items, orderId, orderTotal, orderSubtotal, coupon } = action.payload;
                trackOrderConfirmEvent(entity, {
                    orderId,
                    orderTotal,
                    orderSubtotal,
                    coupon,
                    items,
                });
                break;
            }
            case Actions.WIDGET_APPEAR: {
                const { rfkId, entity, items, request } = action.payload;
                trackViewEvent(rfkId, entity, { ...(items.length > 0 ? { items } : undefined), request });
                break;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange(observable, name, value) {
        if (this.initialized) {
            Dispatcher.dispatch({
                type: Actions.PAGE_CONTEXT_CHANGED,
                payload: { context: this.context },
            });
        }
    }
}
export default new Controller();
